import type { User } from '../model/index.tsx';
import { getUser, getUsers } from '../rest/index.tsx';
import { transformUser, transformUsers } from './transformers.tsx';

export const requestUser = (baseUrl: string, accountId: string): Promise<User> =>
	getUser(baseUrl, accountId).then(transformUser);

export const requestUsers = (baseUrl: string, query: string): Promise<User[]> =>
	getUsers(baseUrl, query).then(transformUsers);
